import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const WhiteboardTokenQuery: GraphQLTaggedNode = graphql`
	query WhiteboardTokenQuery($contentId: ID!) {
		canvasToken(contentId: $contentId) {
			token
		}
		contentMediaSession(contentId: $contentId) {
			accessTokens {
				readOnlyToken {
					value
				}
				readWriteToken {
					value
				}
			}
			configuration {
				fileStoreUrl
			}
		}
		entitlements {
			whiteboardFeatures {
				smartConnectors {
					isEntitled
				}
				smartSections {
					isEntitled
				}
			}
		}
	}
`;
